import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faPause, faForward, faBackward } from '@fortawesome/free-solid-svg-icons'
import NextButton from '../NextButton/NextButton'

function Controls(props) {
    const pageType = window.location.pathname.split("/")[1];

    const onPlaySongClicked = () => {
        props.setIsPlaying((prevState) => !prevState)
        props.playSong()
    }
    return (
        <div className="c-player--controls">
            {/* <button className="skip-btn" onClick={() => props.SkipSong(false)}>
                <FontAwesomeIcon icon={faBackward} />
            </button> */}
            <button className="play-btn" onClick={onPlaySongClicked}>
                <FontAwesomeIcon icon={props.isPlaying ? faPause : faPlay} />
            </button>
            {/* {pageType === 'song' && <NextButton />} */}
        </div>
    )
}

export default Controls
